import { DEFAULT_LOCALE } from '@/config/constants'
import { createI18n } from 'vue-i18n'

import en from './en.js'


//TODO: Pull this from config?
const availableLocales = ['en', 'ja', 'zh-hans', 'zh-hant', 'es', 'pt', 'fr', 'de', 'ko']

// get reference to global window to access local storage
const windowGlobal = typeof window !== 'undefined' && window

export const getDevicePrimaryLocale = () => {
  let l = null
  if (navigator.language) {
    l = navigator.language
  } else if (navigator.languages && navigator.languages > 0) {
    l = navigator.languages[0]
  }
  return l
}

// default locale could be set in localstorage due to user selection...
// otherwise it could be set by the server, or inferred by the browser
// last resort is just to use English
const getDefaultLocale = () => {
  // check for local stored setting
  if (windowGlobal.localStorage.getItem("app:locale") != null) {
    return windowGlobal.localStorage.getItem("app:locale")
  }

  // or config from environment
  if (DEFAULT_LOCALE) {
    return DEFAULT_LOCALE
  }

  // or fall back to guessing from local device
  let deviceLocale = getDevicePrimaryLocale()
  if (deviceLocale) {
    let dlcc = deviceLocale.split("-")
    let country = dlcc[(dlcc.length - 1)]
    let partCode = dlcc[0]

    if (dlcc.length > 1) {dlcc.splice((dlcc.length - 1),1)}
    let fullCode = dlcc.join("-")

    if (availableLocales.indexOf(fullCode) !== -1) {
      return fullCode
    }

    if (partCode === 'zh') {
      return ((country === 'TW') ? 'zh-hant' : 'zh-hans')
    }
  }
  return 'en'
}

let currentLocale = getDefaultLocale()
const i18n = createI18n({
  locale: currentLocale,
  allowComposition: true,
  fallbackLocale: 'en',
  messages: {
    en
  }
})


const setLocale = (locale) => {
  windowGlobal.localStorage.setItem("app:locale", locale)
  currentLocale = locale
}

const getLocale = () => {
  return currentLocale
}

export const translateObjectProperty = (obj, name) => {
  if (obj[name + "I18N"] && obj[name + "I18N"][getLocale()]) {
    return obj[name + "I18N"][getLocale()]
  }
  if (obj[name]) {
    return obj[name]
  }
  return '[i18n error]'
}

//getDeviceLocaleCountryCode return string
export const getDevicePrimaryLocaleCountryCode = () => {
  let dla = null
  let dl = getDevicePrimaryLocale()
  if (dl) {
    dla = dl.split("-")
    return dla[(dla.length - 1)]
  }
}

//getDeviceLocaleLangueCode return string
export const getDevicePrimaryLocaleLanguageCode = () => {
  let dla = null
  let dl = getDevicePrimaryLocale()
  if (dl) {
    dla = dl.split("-")
    if (dla.length > 1) {dla.splice((dla.length - 1),1)}
    return dla.join("-")
  }
}

export default i18n
export { i18n, getLocale, setLocale, getDefaultLocale, availableLocales}
